'use strict';

/**
 *
 */
angular.
module('moebiusProadapt').
service('mbsParticipantService', ['$rootScope', 'moment', '$http', '$timeout', '$q', 'promiseTracker', 'mbsEtiService', '$filter', 'growl', function mbsParticipantServiceFactory($rootScope, moment, $http, $timeout, $q, promiseTracker, mbsEtiService, $filter, growl) {

    this.currentParticipant = null;

    /**
     * remove observer from list (observers, observeds or qrvObservers) by id (QV id or QR key)
     */
    function removeObserverFromListById(observerList,id){
        var index = _.findIndex(observerList, { key: id });
        if(index !==-1)
        {
            observerList.splice(index, 1);
        }
    }

    /**
     * reset data
     */
    this.init = function ()
    {
        this.currentParticipant         = {id:-1};
        $rootScope.participant          = this.currentParticipant;
        $rootScope.participantTracker   = promiseTracker('participantTracker');
    };

    /**
     * @returns Object participant
     */
    this.setCurrentParticipant = function (participant) {
        this.currentParticipant = participant;
        $rootScope.participant = this.currentParticipant;
    };

    /**
     * @returns Object participant
     */
    this.getCurrentParticipant = function () {
        return this.currentParticipant;
    };

    var convertVisiteDateToDateObject = function(visite) {
        if (visite.created_at && _.isString(visite.created_at)) {
            visite.created_at = moment(Date.parse(visite.created_at.replace('-','/','g'))).toDate();
        }
        if (visite.date_end && _.isString(visite.date_end)) {
            visite.date_end = moment(Date.parse(visite.date_end.replace('-','/','g'))).toDate();
        }
        if (visite.date_start && _.isString(visite.date_start)) {
            visite.date_start = moment(Date.parse(visite.date_start.replace('-','/','g'))).toDate();
        }
        if (visite.date_submitted && _.isString(visite.date_submitted)) {
            visite.date_submitted = moment(Date.parse(visite.date_submitted.replace('-','/','g'))).toDate();
        }
        return visite;
    }

    /**
     *  Transform l'objet participant (sans les data)
     *
     * @param partObj
     * @returns {*}
     */
    this.statelessTransformParticipantHeader = function(partObj) {

        // -- Si le participant a déjà été retravaillé Côté JS
        if (partObj.created_at && partObj.created_at instanceof Date) {
            return;
        }

        // -- format Date in JS
        partObj.created_at = moment(Date.parse(partObj.created_at.replace('-','/','g'))).toDate();
        if (partObj.date_j0) {
            partObj.date_j0 = moment(Date.parse(partObj.date_j0.replace('-','/','g'))).toDate();
        }
        if (partObj.date_j0_modifie) {
            partObj.date_j0_modifie = moment(Date.parse(partObj.date_j0_modifie.replace('-','/','g'))).toDate();
        }
        if (partObj.participantPlanningVisitesByVisiteKey) {
            _.each(partObj.participantPlanningVisitesByVisiteKey, function(visitePlanning) {
                _.each(visitePlanning, function (planning) {
                    if (planning.date_previsionnelle) {
                        planning.date_previsionnelle = moment(Date.parse(planning.date_previsionnelle.replace('-','/','g'))).toDate();
                    }
                    if (planning.date_has_been_done) {
                        planning.date_has_been_done = moment(Date.parse(planning.date_has_been_done.replace('-','/','g'))).toDate();
                    }
                })

            });
        }
        var myPartObj = partObj;
        partObj.hasLatePlan = function(todayDate) {
            var hasLateDateCompareToTodayDate = false;
            _.each(myPartObj.participantPlanningVisitesByVisiteKey, function(visitePlanning) {
                _.each(visitePlanning, function (planning) {
                    if (planning.date_previsionnelle && planning.date_previsionnelle < todayDate) {
                        hasLateDateCompareToTodayDate = true;
                    }
                });
            });
            //console.log('hasLateDateCompareToTodayDate' , hasLateDateCompareToTodayDate);
            return hasLateDateCompareToTodayDate;
        };

        if (partObj.participantVisitesByVisiteKey) {
            _.each(partObj.participantVisitesByVisiteKey, function(visite, iVisiteKey) {
                visite = convertVisiteDateToDateObject(visite)
            });
        }




        // -- Participant codified identifier
        partObj.codifiedIdentifier = partObj.centre_id.toLocaleString().padStart(2, '0')
        + '-'
        + partObj.initiale_prenom
        + partObj.initiale_nom
        + '-'
        + partObj.numero.padStart(3, '0')
        ;

        // -- init dcd
        partObj.isDecede = false;

        // -- tooltip text calculation

        partObj.infoTooltip     = ' Créé le ' + $filter('date')(partObj.created_at, 'dd/MM/yyyy HH:mm:ss') + ', inclusion le ' + $filter('date')(partObj.date_inclusion, 'dd/MM/yyyy') ;
        if (partObj.is_optimized) {
            partObj.optimiseTooltip = 'Ce participant est Optimisé';
        } else {
            partObj.optimiseTooltip = 'Ce participant N\'est PAS Optimisé';
        }
        partObj.statusTooltip = $rootScope.constants.participant_status.VALUES_TO_DISPLAY[partObj.status];

        mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys.forEach(function(visiteKey) {
            // -- current Visite = la dernière
            partObj.currentVisiteKey = Object.keys(partObj.participantVisitesByVisiteKey)[Object.keys(partObj.participantVisitesByVisiteKey).length-1];
            var btnStyle = '';
            var tooltip  = '';
            if (visiteKey === partObj.currentVisiteKey
                && partObj.participantVisitesByVisiteKey[visiteKey].status === $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__REJECTED
            ) {
                partObj.isDecede = true;
            }
        });

    };

    this.statelessTransformParticipantValues = function(partObjWithMethodAndValues) {

        if (! partObjWithMethodAndValues.getValue ) {
            throw ('the 1st argument of statelessTransformParticipantValues has to be a ParticipantObject, with its methods ');
        }
        if (! partObjWithMethodAndValues.participantValuesByQuestionVisiteId ) {
            throw ('the 1st argument of statelessTransformParticipantValues has to contains the maps of its values (partObjWithMethodAndValues.participantValuesByQuestionVisiteId) ');
        }

        // -- --
        // -- init et maj des value, si le tableau des value est présent
        var mapQrvKeyVisibility = {};
        if (partObjWithMethodAndValues.participantValuesByQuestionVisiteId) {

            // --
            // -- -- On reset les valeurs de visibilité QUAND ON CHANGE DE PARTICIPANT,
            // -- 1er parcours
            // -- --
            // -- --
            // -- On détecte les QV classiques qui sont Optimisés / non  optimisé,
            // -- et on les positionne en visible / non visible selon le participant
            // -- --
            _.each(partObjWithMethodAndValues.participantValuesByQuestionVisiteId, function(participantValue, iQuestionVisiteId) {
                var questionVisite = mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId];
                var questionMere = mbsEtiService.getCurrentEti().etudedefArray.questionsMeresList[questionVisite.question_mere_key];
                var qrv = _.find(mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList, {id: questionVisite.questionnaire_visite_id});
                questionVisite.previousValue = partObjWithMethodAndValues.getValue(questionVisite);
                questionVisite.cast(partObjWithMethodAndValues);
                questionVisite.setIcon(partObjWithMethodAndValues);

                // -- --
                // -- A - Par défaut, on reinit QRV UNE FOIS comme étant non visible
                // --   -> ON le rend visieble
                // -- --
                if (!mapQrvKeyVisibility[qrv.key]) {
                    // -- -> ATTENTION, sans cela, selon notre navigation entre patient optimisé ou pas optimisé, des QRV cachés étaient montré, et des QRV montré devaient être cachés
                    mapQrvKeyVisibility[qrv.key] = 'hidden';
                    qrv.localAttributes.visible = false;
                }

                // --
                // -- Valeur initiale de la visibilité QV

                // -- a) Visibilité par defaut TRUE selon participant.is_optimized, si applicable
                // -- ATTENTION on exclus les raison non répondu
                if (questionMere.isVisible) {
                    if (
                        // -- pour un optimisé ou pour un both => pour Toutes les questions sauf celle en NON optimisées
                        (partObjWithMethodAndValues.is_optimized && questionVisite.available_for_participant !== $rootScope.constants.available_for_participant.NAMES_TO_VALUES.not_optimized)
                        // -- pour un non optimisé ou pour un both => pour Toutes les questions sauf celle en optimisées
                        || (!partObjWithMethodAndValues.is_optimized && questionVisite.available_for_participant !== $rootScope.constants.available_for_participant.NAMES_TO_VALUES.optimized)
                    ) {
                        // -- alors on initialise pour ce paritcipant à VISIBLE
                        questionVisite.localAttributes.visible = true;
                    }
                }

                // -- b) Visibilité par defaut FALSE selon participant.is_optimized, si applicable
                if (
                    (partObjWithMethodAndValues.is_optimized && questionVisite.available_for_participant === $rootScope.constants.available_for_participant.NAMES_TO_VALUES.not_optimized)
                    || (!partObjWithMethodAndValues.is_optimized && questionVisite.available_for_participant === $rootScope.constants.available_for_participant.NAMES_TO_VALUES.optimized)
                ) {
                    questionVisite.localAttributes.visible = false;
                }

            });



            // --
            // -- -- On reset les valeurs de visibilité QUAND ON CHANGE DE PARTICIPANT,
            // -- 2ème parcours
            // -- --
            // -- --
            // -- -- On lance les notifications pour que les reste des règles de visibilités classique sur Forumla puissent s'appliquer
            // -- --
            _.each(partObjWithMethodAndValues.participantValuesByQuestionVisiteId, function(participantValue, iQuestionVisiteId) {
                var questionVisite = mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId];
                var questionMere = mbsEtiService.getCurrentEti().etudedefArray.questionsMeresList[questionVisite.question_mere_key];
                var qrv = _.find(mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList, {id: questionVisite.questionnaire_visite_id});

                // -- les qvs qui doivent notifier lance leurs notifications
                questionVisite.notification.local.notify(questionVisite, mbsEtiService.getCurrentVisite(), partObjWithMethodAndValues);

                // -- --
                // -- B - Si QRV contient au moins 1 QV visible
                // --   -> ON le rend visieble
                // -- --
                if(questionVisite.localAttributes.visible && questionVisite.questionnaire_visite_id && !qrv.localAttributes.visible && mapQrvKeyVisibility[qrv.key] === 'hidden'){
                    // -- si le QRV n'est pas visible (by default) et qu'il a une qv visible, et qu'on la pas encore mis visible, alors le wrv devient visible
                    qrv.localAttributes.visible = true;
                    mapQrvKeyVisibility[qrv.key] = 'shown';
                }
            });
        }


        if(partObjWithMethodAndValues.participantPecTherapeutiqueByQuestionVisiteId) {
            //parcourir les QV
            _.each(partObjWithMethodAndValues.participantPecTherapeutiqueByQuestionVisiteId, function(questionVisite) {
                _.each(questionVisite, function(traitement) {
                    traitement.classe_molecule = JSON.parse(traitement.classe_molecule) ;
                });
            });
        }
    };

    /**
     * @param participant
     */
    this.initWithParticipant = function(participant)
    {
        this.init();
        this.setCurrentParticipant(participant);

        // -- ------------------
        // -- ParticipantData
        // -- ------------------
        // -- domain object méthodes
        this.currentParticipant.getValue = function(questionVisite) {

            if (questionVisite.overwritePriority !== this.participantValuesByQuestionVisiteId[questionVisite.id].best) {
                console.error('********* CONTROLE: in getValue -> questionVisite.overwritePriority est != de ' + this.participantValuesByQuestionVisiteId[questionVisite.id].best);
            }
            // this = currentParticipant
            return this.participantValuesByQuestionVisiteId[questionVisite.id][this.participantValuesByQuestionVisiteId[questionVisite.id].best];

        }.bind(this.currentParticipant);

        this.currentParticipant.setValue = function(questionVisite, newValue) {

            if (questionVisite.overwritePriority !== this.participantValuesByQuestionVisiteId[questionVisite.id].best) {
                console.error('********* CONTROLE: in setValue -> questionVisite.overwritePriority est != de ' + this.participantValuesByQuestionVisiteId[questionVisite.id].best);
            }
            // this = currentParticipant
            this.participantValuesByQuestionVisiteId[questionVisite.id][questionVisite.overwritePriority] = newValue;

        }.bind(this.currentParticipant);


        this.currentParticipant.getValidationErrors = function(questionVisite) {

            // this = currentParticipant
            return this.participantValuesByQuestionVisiteId[questionVisite.id].validationErrors ;

        }.bind(this.currentParticipant);



        this.currentParticipant.mergeServerData = function(responseDataParticipant) {


            //   -----------------------------------------
            //   -- le code commenté permet de faire un console log de l'ibjet, via un JSON.stringigy, mais AVEC les méthodes !
            //   -- cela permet de traquer les modifications que subit l'objet participant au cours de ce processus de merge
            //   -----------------------------------------
            //
            //     // keep a list of serialized functions
            //     const functions = [];
            //
            // // json replacer - returns a placeholder for functions
            //     const jsonReplacer = function (key, val) {
            //         if (typeof val === 'function') {
            //             functions.push(val.toString());
            //
            //             return "{func_" + (functions.length - 1) + "}";
            //         }
            //
            //         return val;
            //     };
            //
            // // regex replacer - replaces placeholders with functions
            //     const funcReplacer = function (match, id) {
            //         return functions[id];
            //     };

            // console.dir('THIS ' + JSON.stringify(this, jsonReplacer).replace(/"\{func_(\d+)\}"/g, funcReplacer));
            // console.dir('responseDataParticipant ' + JSON.stringify(responseDataParticipant, jsonReplacer).replace(/"\{func_(\d+)\}"/g, funcReplacer));


            // -----------------------------------------
            // -- on merge le résultat dans l'objet AVANT de refaire des traitements de type cast
            // -- Ainsi, on bénéficie déjà, dans THIS, des méthodes getValue, setValue
            angular.extend(this, responseDataParticipant);


            // console.dir('MERGED ' + JSON.stringify(this, jsonReplacer).replace(/"\{func_(\d+)\}"/g, funcReplacer));


            var thatCurrentParticipant = this;

            // -- étape de cast, for example, when receiving date from server, this will ensure they are casted to Date object
            _.each(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList, function(questionVisite) {
                questionVisite.cast(thatCurrentParticipant);

                // -- we ensure that the automatic questions, like score, modified by the server, notify their observers when we come back client side
                if (questionVisite.overwritePriority === 'auto') {
                    questionVisite.notification.local.notify(questionVisite, mbsEtiService.getCurrentVisite(), thatCurrentParticipant);
                }
            });

            if (this.participantVisitesByVisiteKey) {
                _.each(this.participantVisitesByVisiteKey, function(visite, iVisiteKey) {
                    visite = convertVisiteDateToDateObject(visite)
                });
            }

            // console.dir('mergeServerData ' + JSON.stringify(this, jsonReplacer).replace(/"\{func_(\d+)\}"/g, funcReplacer));

        }.bind(this.currentParticipant);



        this.currentParticipant.callbackSaveQuestionsVisites = function(response, questionsVisitesIds, updateProgressOfQuestionnaireVisiteKey) {

            // this = currentParticipant
            console.log('before ' + this.updated_at);

            // -- TODO CE MERGE EST FAUX SUR LE PRINCIPE
            // -- SON AVANTAGE EST DE PROPAGER LES CALCULS COTE SERVEUR AU CLIENT
            // -- MAIS IL A LE DESAVANTAGE D'ECRASER DES CHAMPS NON SAVED !!!

            // -- 1 - retenir tous les isDirty
            var retainedIsDirtyParticipantValuesByQuestionVisiteId = {};
            _.each(this.participantValuesByQuestionVisiteId, function(participantValue, iQuestionVisiteId) {
                if ( mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].isDirty) {
                    retainedIsDirtyParticipantValuesByQuestionVisiteId[iQuestionVisiteId] = participantValue;
                }
            });

            // -- 2 - merge intégral
            this.mergeServerData(response.data.participant);

            // -- 2bis - ceux qui seraient null et dont nd=0 mas pas marqués en NOT_ANSWERED
            _.each(this.participantValuesByQuestionVisiteId, function(participantValue, iQuestionVisiteId) {
                if (
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].stateAnswerAndSave
                    && mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].stateAnswerAndSave !== 'NOT_ANSWERED'
                    && participantValue[participantValue.best] === null && participantValue.nd === 0
                ) {
                    // console.log('Alerting ', mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].stateAnswerAndSave, mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId]);
                    // alert('Now it is NULL ' + mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].key );
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].stateAnswerAndSave = 'NOT_ANSWERED';
                }
            });

            // -- 3 - refresh qv status
            questionsVisitesIds.forEach(function(questionVisiteId) {

                mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].isDirty = false;


                // mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].cast(this);

                // -- si erreur de validation
                if (this.getValidationErrors(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId])) {
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].stateAnswerAndSave = 'NOT_ANSWERED';
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].validationErrors = this.getValidationErrors(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId]);
                }
                // -- si contient une valeur, et n'est pas invalide, c'est qu'on a save quelquechose
                else if (this.getValue(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId]) !== null || this.participantValuesByQuestionVisiteId[questionVisiteId].nd === 1) {
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].stateAnswerAndSave = 'ANSWERED_SAVED';
                    // --- on MAJ la previous value avec ce qui est saved sur le serveur
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].previousValue      = this.getValue(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId]);
                }
            }, this);

            // -- 4 - reintegrate isDirty Ones
            _.each(retainedIsDirtyParticipantValuesByQuestionVisiteId, function(participantValue, iQuestionVisiteId) {
                if ( mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].isDirty) {
                    this.participantValuesByQuestionVisiteId[iQuestionVisiteId] = participantValue;
                    // set correct stateAnswerAndSave value
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[iQuestionVisiteId].stateAnswerAndSave = 'ANSWERED_DIRTY';
                }
            }.bind(this));

            // -- si on appel cette méthode saveQuestionsVisites seule, alors on peut vouloir forcer le refresh des éléments du QRV
            // -- auquel cas, passer sa clé en argument
            if (updateProgressOfQuestionnaireVisiteKey) {
                mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey].updateProgress(this);
                mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey].updateLiveProgress();
                mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey].isDirty = false;
            }
        }.bind(this.currentParticipant);


        this.currentParticipant.saveQuestionsVisites = function(questionsVisitesIds, updateProgressOfQuestionnaireVisiteKey) {

            // this = currentParticipant

            // update value
            var values = {};

            // -- @todo, add the QR date to this list
            if (updateProgressOfQuestionnaireVisiteKey) {
                var questionnaireVisite = mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey];
                if (questionnaireVisite && questionnaireVisite.questionVisiteDate) {
                    questionsVisitesIds.push(questionnaireVisite.questionVisiteDate.id);
                }
            }

            questionsVisitesIds.forEach(function(questionVisiteId) {

                // if (this.participantValuesByQuestionVisiteId[questionVisiteId] !== null) {
                    values[questionVisiteId] = this.participantValuesByQuestionVisiteId[questionVisiteId];
                // }
            }, this);

            var etiId     = mbsEtiService.getCurrentEti().id;
            var visiteKey = mbsEtiService.getCurrentVisite().key;


            var promise = $http.post('etude-instance/save-participant-values/'+ etiId +'/'+ visiteKey +'/'+ this.id, {participantValuesByQuestionVisiteId:values});

            $rootScope.participantTracker.addPromise(promise);

            promise.then(function(response) {
                this.callbackSaveQuestionsVisites(response, questionsVisitesIds, updateProgressOfQuestionnaireVisiteKey);
                // TODO : check with YG if this is the right place
                // add here a confirm for STOPP/START if there was a change in traitements initiaux after the launch of STOPP/START algo
                // get qvId of traitements initiaux
                let initTreatmentsQvId = mbsEtiService.getCurrentVisite().getQuestionVisiteForQuestionMereKeyShort('QM__TRAITEMENT_RECUEIL_INITIAL').id;
                console.log(questionsVisitesIds, mbsEtiService.getCurrentVisite(),initTreatmentsQvId);
                if(questionsVisitesIds.indexOf(initTreatmentsQvId)!==-1) {
                    console.log('changes in traitements initiaux');
                    // detect change on traitements initiaux, if change, display confirm
                    // if suggestions have already been validated, display confirm
                    let confirmMessage = null;
                    let confirmAnswer = false;
                    let initAtcListHasChanged = false;
                    let initAtcListHasAddedTreatment = false;
                    let newInitTreatments = angular.toJson(this.participantTraitementsByQuestionVisiteId[initTreatmentsQvId]);
                    let updateStateOnly = false;
                    let visiteKey;
                    let initAtcListUcd13 = _.map(this.participantTraitementsByQuestionVisiteId[initTreatmentsQvId],function(a){
                        return a.ucd13_specialite_medicamenteuse;
                    }).sort();
                    let ssEtatAtcListUcd13 = _.map(this.participant_ss_etat.traitements_initiaux,function(a){
                        return a.ucd13_specialite_medicamenteuse;
                    }).sort();
                    if(this.participant_ss_etat && angular.toJson(initAtcListUcd13) != angular.toJson(ssEtatAtcListUcd13)) {
                        initAtcListHasChanged = true;
                        // determine if new ATC have been added
                        if(_.difference(initAtcListUcd13, ssEtatAtcListUcd13).length){
                            initAtcListHasAddedTreatment = true;
                        }
                        console.log('initAtcListHasChanged', initAtcListHasAddedTreatment,initAtcListUcd13, ssEtatAtcListUcd13);
                    }
                    if (this.participant_ss_etat && this.participant_ss_etat.questions && initAtcListHasChanged) {
                        confirmMessage = "Les actions conseillées par l'algorithme \"Stopp/Start\" ont été impactées par un changement au niveau de la liste \"Traitements / Recueil initial\" qui impacte peut-être également la conciliation.\n" +
                            "Souhaitez-vous recommencer de zéro tout l'algorithme \"Stopp/Start\" ?";
                    }
                    if (confirmMessage) {
                        confirmAnswer = confirm(confirmMessage);
                    }
                    // re-launch STOPP/START
                    if(confirmMessage && confirmAnswer){
                        $rootScope.$broadcast('eventLaunchSS', {});
                    }
                    //if confirm answer is no, propose to copy newly added init treatments to conciliation medicale
                    if (confirmMessage && !confirmAnswer && initAtcListHasAddedTreatment) {
                        if (confirm("Vous avez choisi de ne pas relancer l'algorithme \"Stopp/Start\". Voulez vous recopier les traitements initiaux ajoutés dans la conciliation médicamenteuse ?")) {
                            visiteKey = mbsEtiService.getCurrentVisite().key;
                            let prom = $http.post('stopp-start/copy-to-conciliation/' + mbsEtiService.getCurrentEti().id + '/' + visiteKey + '/' + this.id)
                                .then(function (response) {
                                    console.log('copy conciliation', response, this);
                                    //update conciliation
                                    let conciliationQvId = mbsEtiService.getCurrentVisite().getQuestionVisiteForQuestionMereKeyShort('QM__TRAITEMENT_CONCILIATION_MEDICAMENTEUSE').id;
                                    this.participantTraitementsByQuestionVisiteId[conciliationQvId] =
                                        response.data.participant_traitements.filter(function(t){
                                            return t.question_visite_def_id === conciliationQvId;
                                        });

                                    // update etat
                                    this.participant_ss_etat = response.data.participant_ss_etat;
                                    growl.success('Traitement(s) recopiés dans \"Conciliation médicamenteuse\"');
                                }.bind(this));
                            $rootScope.participantTracker.addPromise(prom);
                        }else{
                            updateStateOnly = true;
                        }
                    }else{
                        updateStateOnly = true;
                    }
                    // update etat with new list, to prevent confirm from displaying the next time
                    if (updateStateOnly) {
                        visiteKey = mbsEtiService.getCurrentVisite().key;
                        let prom = $http.post('stopp-start/copy-to-conciliation/' + mbsEtiService.getCurrentEti().id + '/' + visiteKey + '/' + this.id,{updateStateOnly:true})
                            .then(function (response) {
                                console.log('update state only', response);
                                this.participant_ss_etat = response.data.participant_ss_etat;
                            }.bind(this));
                        $rootScope.participantTracker.addPromise(prom);
                    }
                }

            }.bind(this));

            return promise;

        }.bind(this.currentParticipant);


        this.currentParticipant.saveQuestionnaireVisite = function(questionnaireVisiteKey) {

            // this = currentParticipant

            // -- retrieve the qv of the qrv
            var questionsVisitesKeys = mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[questionnaireVisiteKey].questionsVisitesOrderedIds;
            // -- then call
            this.saveQuestionsVisites(questionsVisitesKeys).then(function() {
                console.log('in chained promise ' + this.updated_at);

                mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[questionnaireVisiteKey].updateProgress(this);
                mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[questionnaireVisiteKey].isDirty = false;
            }.bind(this));

        }.bind(this.currentParticipant);


        /**
         * When changing a value without saving, but recalculate scores
         *
         * @param questionsVisitesId
         * @param updateProgressOfQuestionnaireVisiteKey
         */
        this.currentParticipant.remoteNoSaveOneQuestionVisite = function(questionVisiteId, updateProgressOfQuestionnaireVisiteKey) {

            // this = currentParticipant

            var participantId = this.id       ? '/' + this.id : '/new';
            var payload     = {
                participantValuesByQuestionVisiteId: this.participantValuesByQuestionVisiteId,
            };
            var etiId     = mbsEtiService.getCurrentEti().id;
            var visiteKey = mbsEtiService.getCurrentVisite().key;

            // -- it is important to send All questionVisites since several could have been modified
            var promise = $http.post( 'etude-instance/change-observed-questionVisite-callback/' + etiId + '/' + visiteKey + participantId, payload);

            $rootScope.participantTracker.addPromise(promise);

            promise.then(function(response) {
                console.log('before change ' + this.updated_at);
                this.mergeServerData(response.data.participant);
                console.log('after change  ' + this.updated_at);

                var hasValidationError = false;

                // -- refresh qv status
                mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].isDirty = true;

                // -- si erreur de validation
                if (this.getValidationErrors(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId])) {
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].stateAnswerAndSave = 'NOT_ANSWERED';
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].validationErrors = this.getValidationErrors(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId]);
                    hasValidationError = true;
                }
                // -- si contient une valeur, et n'est pas invalide, c'est qu'on a save quelquechose
                else if (this.getValue(mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId]) !== null) {
                    mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[questionVisiteId].stateAnswerAndSave = 'ANSWERED_DIRTY';
                }

                // -- si on appel cette méthode saveQuestionsVisites seule, alors on peut vouloir forcer le refresh des éléments du QRV
                // -- auquel cas, passer sa clé en argument
                if (updateProgressOfQuestionnaireVisiteKey && !hasValidationError) {
//...                    mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey].updateProgress(this);
                    mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey].isDirty = true;

                    // update live progress
                    mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[updateProgressOfQuestionnaireVisiteKey].updateLiveProgress();
                }

            }.bind(this));

            return promise;

        }.bind(this.currentParticipant);

    };

}]);




// WEBPACK FOOTER //
// ./resources/assets/js/services/mbs-participant-service.js